import { Option } from '../types/main';

export const OrderStatuses: Option[] = [
  { key: 'invalid', label: 'Invalid' },
  { key: 'created', label: 'Created' },
  { key: 'in_progress', label: 'In Progress' },
  { key: 'review', label: 'Review' },
  { key: 'invoiced', label: 'Invoiced' },
  { key: 'paid', label: 'Paid' },
  { key: 'cancelled', label: 'Cancelled' },
  { key: 'error', label: 'Error' },
];
